export default {
    capabilities: (state) => state.capabilities,
    clientConfig: (state) => state.clientConfig,
    council: (state) => state.council,
    currentClient: (state) => state.currentClient,
    currentEvent: (state) => state.currentEvent,
    currentGuard: (state) => state.currentGuard,
    currentMeeting: (state) => state.currentMeeting,
    currentPerson: (state) => state.currentPerson,
    currentProfile: (state) => state.currentProfile,
    currentResource: (state) => state.currentResource,
    currentShift: (state) => state.currentShift,
    currentSurvey: (state) => state.currentSurvey,
    currentUnit: (state) => state.currentUnit,
    currentUser: (state) => state.currentUser,
    currentVenue: (state) => state.currentVenue,
    currentWorkplace: (state) => state.currentWorkplace,
    guardNotifications: (state) => state.guardNotifications,
    inProgress: (state) => !!state.pendingRequests,
    isAuthenticated: (state) => !!state.currentUser,
    isReseller: (state) => state.isReseller,
    menu: (state) => createMenu(state),
    personRoles: (state) => state.personRoles,
    polls: (state) => state.polls,
    systemParams: (state) => state.systemParams,
    task: (state) => state.task,
    userPollsReady: (state) => state.userPollsReady,
    // chat
    agent: (state) => state.agent,
    agentConnection: (state) => state.agentConnection,
    isAgent: (state) => !!state.agent,
    loginInProgress: (state) => state.loginInProgress,
}

const createMenu = (state) => {
    const currentVenue = state.currentVenue
    let currentVenueModules = []
    if (currentVenue && currentVenue.modules) {
        currentVenueModules = currentVenue.modules.map((module) => module.id)
        const filteredMenus = state.menu.map((menu) => {
            const filteredMenuItems = menu.menuItems.filter((menuItem) => {
                const moduleIds = (menuItem.modules || []).map((module) => module.id)
                return moduleIds.some((moduleId) => currentVenueModules.includes(moduleId))
            })
            if (filteredMenuItems.length > 0) {
                return {
                    ...menu,
                    menuItems: filteredMenuItems,
                }
            }
        })
        return filteredMenus.filter((menu) => !!menu)
    } else {
        return state.menu
    }
}
